export var DefaultTooltipDirectionStyles = {
    directionalContainerStyles: {
        alignItems: null,
        justifyContent: null,
    },
    tooltipContainerStyles: {
        top: function () { return null; },
        bottom: function () { return null; },
        left: function () { return null; },
        right: function () { return null; },
    },
    tooltipArrowStyles: {
        boxShadowSizing: null,
        top: null,
        left: null,
    },
};
//# sourceMappingURL=DefaultTooltipDirectionStyles.js.map